import api from '../apis/api'
import { tokenConfig } from '../config'

export const GetDashboardAPI = (id, query, state) => {
  return new Promise((res, rej) => {
    api.get(`/dashboard/${id}/?${query}`, tokenConfig(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}